import { useContext } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export function useIsRouting() {
  const navigation = useContext(UNSAFE_NavigationContext);
  return navigation != null;
} 